import*as e from"react";import r from"../setRef/setRef.js";function t(...t){return e.useMemo((()=>t.every((e=>null==e))?null:e=>{t.forEach((t=>{r(t,e)}))}),t)}export{t as default};
//# sourceMappingURL=useForkRef.js.map
